/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M10.1938 14.9358L8.48286 12.9804C7.37665 11.7162 6.82355 11.0841 6.80642 10.5479C6.79153 10.082 6.99405 9.63573 7.35445 9.34017C7.76923 9 8.60917 9 10.289 9H13.711C15.3908 9 16.2308 9 16.6455 9.34017C17.0059 9.63573 17.2085 10.082 17.1936 10.5479C17.1765 11.0841 16.6233 11.7162 15.5171 12.9804L13.8062 14.9358C13.1826 15.6485 12.8708 16.0048 12.5013 16.1358C12.177 16.2509 11.823 16.2509 11.4987 16.1358C11.1292 16.0048 10.8174 15.6485 10.1938 14.9358Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22 10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10ZM13.8062 14.9358C13.1826 15.6485 12.8708 16.0048 12.5013 16.1358C12.177 16.2509 11.823 16.2509 11.4987 16.1358C11.1292 16.0048 10.8174 15.6485 10.1938 14.9358L8.48286 12.9804C7.37665 11.7162 6.82355 11.0841 6.80642 10.5479C6.79153 10.082 6.99405 9.63573 7.35445 9.34017C7.76923 9 8.60917 9 10.289 9H13.711C15.3908 9 16.2308 9 16.6455 9.34017C17.0059 9.63573 17.2085 10.082 17.1936 10.5479C17.1765 11.0841 16.6233 11.7162 15.5171 12.9804L13.8062 14.9358Z"
				fill="currentColor"
			/>
			<path
				d="M2 10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V10Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.8062 14.9358C13.1826 15.6485 12.8708 16.0048 12.5013 16.1358C12.177 16.2509 11.823 16.2509 11.4987 16.1358C11.1292 16.0048 10.8174 15.6485 10.1938 14.9358L8.48286 12.9804C7.37665 11.7162 6.82355 11.0841 6.80642 10.5479C6.79153 10.082 6.99405 9.63573 7.35445 9.34017C7.76923 9 8.60917 9 10.289 9H13.711C15.3908 9 16.2308 9 16.6455 9.34017C17.0059 9.63573 17.2085 10.082 17.1936 10.5479C17.1765 11.0841 16.6233 11.7162 15.5171 12.9804L13.8062 14.9358Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM9.09702 13.0971L10.3029 14.3029C10.8969 14.897 11.1939 15.194 11.5364 15.3053C11.8377 15.4032 12.1622 15.4032 12.4635 15.3053C12.806 15.194 13.103 14.897 13.697 14.3029L13.697 14.3029L14.9029 13.0971C16.188 11.8119 16.8306 11.1694 16.874 10.6177C16.9117 10.139 16.7179 9.67123 16.3528 9.35939C15.932 9 15.0233 9 13.2059 9H10.7941C8.97663 9 8.06791 9 7.64711 9.35939C7.282 9.67123 7.08824 10.139 7.12591 10.6177C7.16933 11.1694 7.81189 11.8119 9.09702 13.0971Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M15.5171 12.9804L13.8062 14.9358C13.1826 15.6485 12.8708 16.0048 12.5013 16.1358C12.177 16.2509 11.823 16.2509 11.4987 16.1358C11.1292 16.0048 10.8174 15.6485 10.1938 14.9358L8.48286 12.9804C7.37665 11.7162 6.82355 11.0841 6.80642 10.5479C6.79153 10.082 6.99405 9.63573 7.35445 9.34017C7.76923 9 8.60917 9 10.289 9H13.711C15.3908 9 16.2308 9 16.6455 9.34017C17.0059 9.63573 17.2085 10.082 17.1936 10.5479C17.1765 11.0841 16.6233 11.7162 15.5171 12.9804Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2 10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V10Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.8062 14.9358C13.1826 15.6485 12.8708 16.0048 12.5013 16.1358C12.177 16.2509 11.823 16.2509 11.4987 16.1358C11.1292 16.0048 10.8174 15.6485 10.1938 14.9358L8.48286 12.9804C7.37665 11.7162 6.82355 11.0841 6.80642 10.5479C6.79153 10.082 6.99405 9.63573 7.35445 9.34017C7.76923 9 8.60917 9 10.289 9H13.711C15.3908 9 16.2308 9 16.6455 9.34017C17.0059 9.63573 17.2085 10.082 17.1936 10.5479C17.1765 11.0841 16.6233 11.7162 15.5171 12.9804L13.8062 14.9358Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				d="M10.3027 14.3029L9.09684 13.0971C7.81171 11.8119 7.16914 11.1694 7.12573 10.6177C7.08805 10.139 7.28182 9.67123 7.64693 9.35939C8.06772 9 8.97645 9 10.7939 9H13.2057C15.0231 9 15.9318 9 16.3526 9.35939C16.7177 9.67123 16.9115 10.139 16.8738 10.6177C16.8304 11.1694 16.1879 11.8119 14.9027 13.0971L13.6968 14.3029L13.6968 14.3029C13.1028 14.897 12.8058 15.194 12.4633 15.3053C12.162 15.4032 11.8375 15.4032 11.5363 15.3053C11.1938 15.194 10.8968 14.897 10.3027 14.3029Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
